/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ReassignTodoRequest
 */
export interface ReassignTodoRequest {
  /**
   *
   * @type {string}
   * @memberof ReassignTodoRequest
   */
  assignee: string;
}

/**
 * Check if a given object implements the ReassignTodoRequest interface.
 */
export function instanceOfReassignTodoRequest(
  value: object,
): value is ReassignTodoRequest {
  if (!("assignee" in value) || value["assignee"] === undefined) return false;
  return true;
}

export function ReassignTodoRequestFromJSON(json: any): ReassignTodoRequest {
  return ReassignTodoRequestFromJSONTyped(json, false);
}

export function ReassignTodoRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ReassignTodoRequest {
  if (json == null) {
    return json;
  }
  return {
    assignee: json["assignee"],
  };
}

export function ReassignTodoRequestToJSON(json: any): ReassignTodoRequest {
  return ReassignTodoRequestToJSONTyped(json, false);
}

export function ReassignTodoRequestToJSONTyped(
  value?: ReassignTodoRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    assignee: value["assignee"],
  };
}
